import { LocaleResources } from 'locales';
import React from 'react';
import { Product } from 'src/models/product/schema';
import styles from '../index.module.scss';
import clsx from 'clsx';
import { toJSX } from 'src/utils/toJSXHelper';

type Props = {
  localeResources: LocaleResources;
  product: Product;
};

export const Information: React.FC<Props> = ({ product, localeResources }) => {
  return (
    <div className={clsx(styles.wrap, styles.mb5)}>
      <div className={styles.bold}>■{localeResources.products.medicine.Information.title}</div>
      <div className={styles.mt10}>
        <p>
          {toJSX(
            localeResources.products.medicine.Information.desc(product ? product.medicalRiskType : '', styles.pink),
          )}
        </p>
      </div>
    </div>
  );
};
